/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, action: NonNullable<unknown>, rate: NonNullable<unknown> }} Seo_Title_Endpoint_PriceInputs */

const en_seo_title_endpoint_price = /** @type {(inputs: Seo_Title_Endpoint_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action} API - ${i?.rate}`)
};

const zh_hans1_seo_title_endpoint_price = /** @type {(inputs: Seo_Title_Endpoint_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action} API：${i?.rate}`)
};

const pt_br2_seo_title_endpoint_price = /** @type {(inputs: Seo_Title_Endpoint_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API para ${i?.name}: ${i?.action} - ${i?.rate}`)
};

const es_seo_title_endpoint_price = /** @type {(inputs: Seo_Title_Endpoint_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API de ${i?.name}: ${i?.action} - ${i?.rate}`)
};

const fr_seo_title_endpoint_price = /** @type {(inputs: Seo_Title_Endpoint_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API ${i?.name} ${i?.action} - ${i?.rate}`)
};

const de_seo_title_endpoint_price = /** @type {(inputs: Seo_Title_Endpoint_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}-${i?.action}-API: ${i?.rate}`)
};

const ru_seo_title_endpoint_price = /** @type {(inputs: Seo_Title_Endpoint_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API ${i?.name} ${i?.action} - ${i?.rate}`)
};

const it_seo_title_endpoint_price = /** @type {(inputs: Seo_Title_Endpoint_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API ${i?.name} ${i?.action} - ${i?.rate}`)
};

/**
* | output |
* | --- |
* | "{name} {action} API - {rate}" |
*
* @param {Seo_Title_Endpoint_PriceInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_title_endpoint_price = /** @type {((inputs: Seo_Title_Endpoint_PriceInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Title_Endpoint_PriceInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_title_endpoint_price(inputs)
	if (locale === "pt-BR") return pt_br2_seo_title_endpoint_price(inputs)
	if (locale === "es") return es_seo_title_endpoint_price(inputs)
	if (locale === "fr") return fr_seo_title_endpoint_price(inputs)
	if (locale === "de") return de_seo_title_endpoint_price(inputs)
	if (locale === "ru") return ru_seo_title_endpoint_price(inputs)
	if (locale === "it") return it_seo_title_endpoint_price(inputs)
	return en_seo_title_endpoint_price(inputs)
});